import { StatusBar } from 'expo-status-bar';
import 'react-native-gesture-handler';
import 'react-native-reanimated'
import React, { Component } from 'react';
import { useState } from 'react';
import { Text, ImageBackground, View, Image, Alert, TouchableOpacity, Platform, Dimensions } from 'react-native';
import api from './components/config/api_urls';
import * as Font from 'expo-font';
import * as RNLocalize from "react-native-localize";
import ReactMarkdown from 'react-markdown';
import * as WebBrowser from 'expo-web-browser';
import { setAnalyticsCollectionEnabled } from 'expo-firebase-analytics';
import 'react-native-gesture-handler';
//Navegacio
import { createStackNavigator } from '@react-navigation/stack';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
//import Proves from './components/proves/proves';
import Home from './components/home/home';
import Prova from './components/proves/proves';
import Inici from './components/inici/inici';
import Telefon from './components/telefon/telefon'
import Login from './components/login/login';
import Perfil from './components/perfil/perfil';
import Joc1 from './components/joc1/joc1';
import Joc2 from './components/joc2/joc2';
import Joc3 from './components/joc3/joc3'; 
import Joc3Completa from './components/joc3/joc3PantallaComplerta';
import Credits from './components/credits/credits';
import Rondalla from './components/laRondalla/rondalla';
import Pagina6  from './components/laRondalla/pagina6';
import AsyncStorage from '@react-native-community/async-storage';
import VideoPantallaComplerta from './components/video/video';
import MenuPosicionament from './components/menuClio/menuClio';
import Animated, { useSharedValue } from 'react-native-reanimated';

//Style caixeti
import style from './components/credits/style';

import * as ScreenOrientation from 'expo-screen-orientation';
import PrefilMulti from './components/perfil/perfilMulti/perfilMulti';
import ImatgesItinerari from './components/perfil/imatgesItinerari';
import Joc360 from './components/joc360/joc360';
import VistaVR from './components/joc360/VistaVR';
import Premi360 from './components/joc360/premi360';
import Intro360 from './components/joc360/intro';
import Avinyo from './components/credits/avinyo';
import Main from './components/Main/Main';

//ordre 0

// Call initialParams in Class Main
///////////////////////* NAVIGATION PART *///////////////////////////////



const Stack = createStackNavigator();



const getIdioma = () => {
    let locales = RNLocalize.getLocales();
    if (Array.isArray(locales)) {
      //Agafa el primer idioma del telefon
      locales = locales[0].languageTag;
    }
    console.log(locales);
    console.log(locales.substring(0,2));
    switch(locales.substring(0,2)) {
      case 'es':
        AsyncStorage.setItem('idioma','_ES');
        return('_ES');
        break;
      case 'en':
        AsyncStorage.setItem('idioma','_EN');
        return('_EN');
        break;
      case 'fr':
        AsyncStorage.setItem('idioma','_FR');
        return('_FR');
        // this.setState({idioma: '_FR'});
        break;
      default:
        AsyncStorage.setItem('idioma','');
        return('');
        // this.setState({idioma: ''});
      break;
    }
} 


const App = () => (
  Font.loadAsync({
    //'Lobster': require('./assets/fonts/Carolingia.otf'), // CLIO
     'Lobster': require('./assets/fonts/Formata.otf'), // Vestigis
     'Brushway': require('./assets/fonts/Brushways-VGAA0.ttf'), // 'Brushway
    //'Lobster': require('./assets/fonts/Lobster.ttf'), // Met De Ribes
    'OpenSans': require('./assets/fonts/Open_Sans/OpenSans-Regular.ttf')
  }),

  <NavigationContainer>
    <Stack.Navigator screenOptions={{
      headerShown: false,
    }} >
      
      <Stack.Screen name="Main" component={Main} initialParams={{idioma:getIdioma(),}}  />
      <Stack.Screen name="Login" component={Login} />
      <Stack.Screen name="Inici" component={Inici} />
      <Stack.Screen name="Rondalla" component={Rondalla} />
      <Stack.Screen name="Pagina6" component={Pagina6} />
      <Stack.Screen name="Home" component={MenuPosicionament}/>
      {/* <Stack.Screen name="Home" component={Home} /> */}
      <Stack.Screen name="Joc1" component={Joc1} />
      <Stack.Screen name="Joc2" component={Joc2} />
      <Stack.Screen name="Video" component={VideoPantallaComplerta} />
      <Stack.Screen name="Joc3" component={Joc3} />
      <Stack.Screen name="Joc3Completa" component={Joc3Completa} />
      <Stack.Screen name="PrefilMulti" component={PrefilMulti} />
      <Stack.Screen name="Vista360" component={VistaVR} />
      <Stack.Screen name="imatgeItinerari" component={ImatgesItinerari} />
      <Stack.Screen name="Premi360" component={Premi360} />
      <Stack.Screen name="Intro360" component={Intro360} />
      <Stack.Screen name="Joc360" component={Joc360}/>
      <Stack.Screen name="Avinyo" component={Avinyo} />
      <Stack.Screen name="Perfil" component={Perfil} />
      <Stack.Screen name="Credits" component={Credits} />
      <Stack.Screen name="Telefon" component={Telefon} />
    </Stack.Navigator>
  </NavigationContainer>
)

export default App;